"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var E=(T=>(T.HIGHEST="HIGHEST",T.MEDIUM="MEDIUM",T.LOWEST="LOWEST",T.NOT_ESTIMATED="NOT_ESTIMATED",T))(E||{});exports.SlotPriority=E;
